import maskInput from "vanilla-text-mask";
import Choices from "choices.js";
import baron from "baron";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default function SearchResults(container) {
    let updateTimer = 0;
    let isSearchResultsOpenButtonActive = false;

    const form = document.getElementById("search-results-form");
    form.setAttribute("novalidate", true);

    const formUrl = form.action;

    form.addEventListener("submit", function(e) {
        e.preventDefault();
        setUpdateRequest();
    });

    const selectBlocks = document.querySelectorAll(".js-search-results-select-block");
    const selectBlockSearching = document.querySelector(".js-search-results-select-block-searching");

    selectBlocks.forEach( function(selectBlock) {
        initSelect(selectBlock);
    });

    initSelect(selectBlockSearching, true);

    const datepickerContainer = document.querySelector(".js-search-results-datepicker-container");
    const datepickerInputs = document.querySelectorAll(".js-search-results-datepicker");
    const flatpickrOptions = {
        allowInput: true,
        static: true,
        dateFormat: "d.m.Y",
        nextArrow: "&raquo;",
        prevArrow: "&laquo;",
        "locale": Russian
    }

    const flatpickrFromOptions = Object.assign({}, flatpickrOptions);
    flatpickrFromOptions.defaultDate = "01.09.18";

    const datepickerFrom = flatpickr(datepickerInputs[0], flatpickrFromOptions);

    const datepickerTo = flatpickr(datepickerInputs[1], flatpickrOptions);

    maskInput({
        inputElement: datepickerInputs[1],
        mask: [/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/]
    });

    datepickerInputs[0].addEventListener("blur", function() {
        datepickerFrom.setDate(this.value);
    });

    datepickerInputs[1].addEventListener("blur", function() {
        datepickerTo.setDate(this.value);
    });

    // const inputText = container.querySelector(".js-search-results-input-text");

    const contentBlock = document.getElementById("search-results-content");

    initSearchResultsOpenButtons();


    function initSelect(selectBlock, isSearching) {
        const selectBaseClass = selectBlock.getAttribute("data-base-class");
        const selectElement = selectBlock.querySelector("select");
        const choicesOptions = {
            shouldSort: false,
            classNames: {
                containerOuter: selectBaseClass + "__container",
                containerInner: selectBaseClass + "__inner",
                list: selectBaseClass + "__list",
                listSingle: selectBaseClass + "__label",
                listDropdown: selectBaseClass + "__dropdown",
                item: selectBaseClass + "__item",
                itemSelectable: "",
                itemChoice: selectBaseClass + "__dropdown-item",
                input: "select__input-search",
                inputCloned: "select__input-search_cloned"
            },
            callbackOnCreateTemplates: function (template) {
                const classNames = this.config.classNames;
                return {
                    dropdown: () => {
                        return template(`
                            <div class="${classNames.listDropdown} js-select-scroller" aria-expanded="false"></div>
                        `);
                    }
                };
            }
        };

        if (!isSearching) {
            choicesOptions.searchEnabled = false;
        }

        if (isSearching) {
            choicesOptions.searchFields = "label";
            choicesOptions.searchResultLimit = 99;
            choicesOptions.noResultsText = "Ничего не найдено";
            choicesOptions.fuseOptions = {
                tokenize: true,
                threshold: 0,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 1
            };
        }

        new Choices(selectElement, choicesOptions);

        const selectDropdownBody = document.createElement("div");
        selectDropdownBody.className = selectBaseClass + "__dropdown-body";
        const baronScrollerContainer = selectBlock.querySelector(".js-select-scroller");
        const baronScroller = baronScrollerContainer.querySelector(".select__list");
        const selectScrollTrack = document.createElement("div");
        selectScrollTrack.className = selectBaseClass + "__scrolltrack";
        const selectScrollBar = document.createElement("div");
        selectScrollBar.className = selectBaseClass + "__scrollbar";
        selectScrollTrack.appendChild(selectScrollBar);
        baronScrollerContainer.appendChild(selectDropdownBody);
        selectDropdownBody.appendChild(baronScroller);
        baronScrollerContainer.appendChild(selectScrollTrack);

        const customScroll = baron({
            root: baronScrollerContainer,
            cssGuru: true,
            scroller: baronScroller,
            barOnCls: selectBaseClass + "__dropdown_scrolling",
            bar: selectScrollBar,
            direction: "v"
        });
        customScroll.controls({
            track: selectScrollTrack
        });

        selectElement.addEventListener("change", function() {
            setUpdateRequest();
        });
    }

    function initSearchResultsOpenButtons() {
        const searchResultsOpenButton = document.getElementById("search-results-open-button");

        if (searchResultsOpenButton) {
            isSearchResultsOpenButtonActive = false;
            const buttonBaseText = searchResultsOpenButton.innerText;
            const buttonActiveText = searchResultsOpenButton.getAttribute("data-active-text");

            const sectionOpenInputs = document.querySelectorAll(".js-search-results-section-open-input");
            const sectionOpenInputsFlags = [];

            sectionOpenInputs.forEach( function(input, index) {
                initSectionOpenInput(input, sectionOpenInputsFlags, index, searchResultsOpenButton, buttonBaseText, buttonActiveText);
            });

            searchResultsOpenButton.addEventListener("click", function() {
                if (isSearchResultsOpenButtonActive) {
                    setSectionOpenInputsValues(sectionOpenInputs, false);
                    deactivateSearchResultsOpenButton(searchResultsOpenButton, buttonBaseText);
                } else {
                    setSectionOpenInputsValues(sectionOpenInputs, true);
                    activateSearchResultsOpenButton(searchResultsOpenButton, buttonActiveText);
                }
            });
        }
    }

    function getSectionInputsActivity(inputsFlags) {
        let isActive;
        let isNotActive;

        inputsFlags.forEach(function(flag) {
            if (flag) {
                isActive = true;
            } else {
                isNotActive = true;
            }
        });

        if (isActive && !isNotActive) {
            return "all";
        } else if (!isActive && isNotActive) {
            return "none";
        }

        return false;
    }

    function activateSearchResultsOpenButton(button, text) {
        isSearchResultsOpenButtonActive = true;
        button.innerText = text;
    }

    function deactivateSearchResultsOpenButton(button, text) {
        isSearchResultsOpenButtonActive = false;
        button.innerText = text;
    }

    function initSectionOpenInput(input, inputsFlags, index, searchResultsOpenButton, buttonBaseText, buttonActiveText) {
        inputsFlags[index] = input.checked;

        input.addEventListener("change", function() {
            inputsFlags[index] = input.checked;
            const status = getSectionInputsActivity(inputsFlags);

            if (status == "all" && !isSearchResultsOpenButtonActive) {
                activateSearchResultsOpenButton(searchResultsOpenButton, buttonActiveText);
            } else if (status == "none" && isSearchResultsOpenButtonActive) {
                deactivateSearchResultsOpenButton(searchResultsOpenButton, buttonBaseText);
            }
        });
    }

    function setSectionOpenInputsValues(inputs, value) {
        for (let i = 0, len = inputs.length; i < len; i++) {
            inputs[i].checked = value;
        }
    }

    function setUpdateRequest() {
        clearTimeout(updateTimer);

        updateTimer = setTimeout(function() {
            sendUpdateRequest();
        }, 700);
    }

    function sendUpdateRequest() {
        const formData = new FormData(form);

        fetch(formUrl, {
            method: "POST",
            body: formData
        }).then(function(response) {
            if (response.ok) {
                return response.json();
            }

            throw new Error("Network response was not ok.");
        }).then(function(responseData) {
            while (contentBlock.firstChild) {
                contentBlock.removeChild(contentBlock.firstChild);
            }

            contentBlock.innerHTML = responseData.content;

            initSearchResultsOpenButtons();
        });
    }
}